import { useEffect } from 'react';
import { useGetDraftJobPost } from '~/domain/PermanentJobs';
import { showErrorMessage } from '~/domain/utils';

export const useDraftJobPost = (jobPostingId: string | undefined) => {
  const { data, error, isError, isLoading } = useGetDraftJobPost(jobPostingId);

  useEffect(() => {
    if (isError) {
      showErrorMessage({ error });
    }
  }, [isError, error]);

  return {
    draft: data,
    isLoading,
  };
};
